export type ViewId = 'vision' | 'portfolio' | 'inventario' | 'arbol' | 'huecos';

export interface RouteDef {
  id: ViewId;
  label: string;
  icon: string;
  group?: string;
}

export const ROUTES: RouteDef[] = [
  { id: 'vision', label: 'Visión Pulse', icon: '🎬', group: 'Presentación' },
  { id: 'portfolio', label: 'Portfolio SKUs', icon: '📦', group: 'Catálogos' },
  { id: 'inventario', label: 'Inventario', icon: '🧬', group: 'Catálogos' },
  { id: 'arbol', label: 'Árbol jerárquico', icon: '🌳', group: 'Análisis' },
  { id: 'huecos', label: 'Huecos argumentales', icon: '⚠️', group: 'Documentación' },
];

type Listener = (view: ViewId) => void;
const listeners: Listener[] = [];

export function currentView(): ViewId {
  const h = window.location.hash.replace(/^#\/?/, '');
  const found = ROUTES.find((r) => r.id === h);
  return (found?.id ?? 'vision') as ViewId;
}

export function navigate(view: ViewId): void {
  if (window.location.hash !== `#/${view}`) {
    window.location.hash = `#/${view}`;
  } else {
    listeners.forEach((l) => l(view));
  }
}

export function onRouteChange(fn: Listener): () => void {
  listeners.push(fn);
  const handler = () => fn(currentView());
  window.addEventListener('hashchange', handler);
  return () => {
    const i = listeners.indexOf(fn);
    if (i >= 0) listeners.splice(i, 1);
    window.removeEventListener('hashchange', handler);
  };
}
